import { supabase } from "@/integrations/supabase/client";

export function trackEvent(event: string, devMode = false) {
  console.log(`[Analytics] ${event}`);
  if (devMode) return;
  supabase.from("analytics_events").insert({ event }).then();
}
